module.exports = __webpack_public_path__ + "img/suit-02.af1de8d3.png";